import { HttpResponse } from '@angular/common/http';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { finalize } from 'rxjs/operators';
import { FilesManagerService } from 'src/app/services/files-manager.service';
import { LoaderProvider } from 'src/app/utils/providers/loader-provider';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-multi-card-actions',
  templateUrl: './multi-card-actions.component.html',
  styleUrls: ['./multi-card-actions.component.scss']
})
export class MultiCardActionsComponent implements OnInit {
  @Input() data: any;
  form: FormGroup;
  file: string | ArrayBuffer;
  file2: string | ArrayBuffer;
  file3: string | ArrayBuffer;
  messages: any[] = [];

  /* Modal cases
    1: img, title, subTitle, order.
    2: img, title as 'Texto', order.
    3: name as 'Texto'
    4: img, name as 'Text'
    5: title, subtitle
    6: title, subtitle, orderId
    7: img, pdf, doc, docx, xls, xlsx
    8: name as 'Rich Text'
    9: 3 images - new FondosMax
    10: Rentas Vitalicias - Body: Img, title, subtitle, orderId
    11: Texto and Link
    12: img, title, subTitle, subTitle2, order.    
   */
  maxLength: number;
  allRecords: number = 0;
  constructor(private fb: FormBuilder,
    public activeModal: NgbActiveModal,
    private filesManagerService: FilesManagerService,
    private loader: LoaderProvider,
  ) {
  }

  ngOnInit(): void {
    this.form = this.fb.group({
      id: [this.data.id || null],
      codeImg: [this.data['modal'].codeImg || null],
      img: [this.data.img || null],
      imgClean: [this.data.imgClean || false],
      img64: [this.data.img || null],
      img64Upload: [this.data && this.data.img ? false : null],
      orderId: [this.data.orderId || null],
      status: [(this.data && this.data.status ? (this.data.status === 'Activo' ? 1 : 0) : null)],
      title: [this.data.title || ''],
      subTitle: [this.data.subTitle || ''],
      subTitle2: [this.data.subTitle2 || ''],
      name: [this.data.name || null],
      url: [this.data.url || null],
      size: [this.data.size || null],
      type: [this.data.type || null],
      toReplace: [false || null],
      img2: [this.data.img2 || null],
      img2Clean: [this.data.img2Clean || false],
      img642: [this.data.img2 || null],
      img642Upload: [this.data && this.data.img2 ? false : null],
      img3: [this.data.img3 || null],
      img3Clean: [this.data.img3Clean || false],
      img643: [this.data.img3 || null],
      img643Upload: [this.data && this.data.img3 ? false : null],
    });
    this.caseValidator();
  }

  caseValidator(): void {
    switch (this.data['modal'].type) {
      case 1:
        this.maxLength = 250;
        this.form.get('img64').setValidators([Validators.required]);
        this.form.get('orderId').setValidators([Validators.required]);
        if (!this.data['modal'].codeImg) {
          this.form.get('codeImg').setValue(2);
        }
        break;
      case 2:
        this.form.get('title').setValidators([Validators.required]);
        this.form.get('subTitle').setValue(null);
        this.form.get('orderId').setValidators([Validators.required]);
        break;
      case 3:
        if (this.form.value.name.length > 400) {
          this.maxLength = 1500;
        } else {
          this.maxLength = 250;
        }
        this.form.get('name').setValidators([Validators.required]);
        this.form.get('title').setValue(null);
        this.form.get('subTitle').setValue(null);
        break;
      case 4:
        this.maxLength = 600;
        this.form.get('title').setValue(null);
        this.form.get('subTitle').setValue(null);
        break;
      case 5:
        this.maxLength = 300;
        this.form.get('title').setValidators([Validators.required]);
        this.form.get('subTitle').setValidators([Validators.required]);
        break;
      case 6:
        this.maxLength = 800;
        this.form.get('title').setValidators([Validators.required]);
        this.form.get('subTitle').setValidators([Validators.required]);
        this.form.get('orderId').setValidators([Validators.required]);
        break;
      case 7:
        this.form.get('img64').setValidators([Validators.required]);
        this.form.get('title').setValue(null);
        this.form.get('subTitle').setValue(null);
        break;
      case 8:
        this.maxLength = 7800;
        this.form.get('name').setValidators([Validators.required]);
        this.form.get('title').setValue(null);
        this.form.get('subTitle').setValue(null);
        break;
      case 9:
        this.form.get('img64').setValidators([Validators.required]);
        this.form.get('imgClean').setValue(false);
        this.form.get('img2Clean').setValue(false);
        this.form.get('img3Clean').setValue(false);
        this.form.get('img642Upload').setValue(false);
        this.form.get('img643Upload').setValue(false);
        this.form.get('title').setValue(null);
        this.form.get('subTitle').setValue(null);
        break;
      case 10:
        this.maxLength = 800;
        this.form.get('img64').setValidators([Validators.required]);
        this.form.get('title').setValidators([Validators.required]);
        this.form.get('subTitle').setValidators([Validators.required]);
        this.form.get('orderId').setValidators([Validators.required]);
        break;
      case 11:
        if (this.form.value.name.length > 400) {
          this.maxLength = 1500;
        } else {
          this.maxLength = 250;
        }
        this.form.get('name').setValidators([Validators.required]);
        this.form.get('img').setValidators([Validators.required]);
        this.form.get('title').setValue(null);
        this.form.get('subTitle').setValue(null);
        break;
      case 12:
        this.form.get('title').setValidators([Validators.required]);
        this.form.get('subTitle').setValidators([Validators.required]);
        this.form.get('subTitle2').setValidators([Validators.required]);
        this.form.get('orderId').setValidators([Validators.required]);
        break;
    }
  }

  imageUpload(event, order?: number): void {
    order = order ?? 1;
    const reader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = (e) => {

      if ([7, 9].includes(this.data['modal'].type)) {
        this.fileManager(event, reader, e, order);
      } else {
        const image = new Image();
        image.src = String(reader.result);
        image.onload = () => {
          this.messages['i'] = null;
          this.file = image.src;
          this.form.get('img').setValue((event.target.files[0]).name);
          this.form.get('img64').setValue(this.file.split(',')[1]);
          this.form.get('img64Upload').setValue(true);
        }
      }

    };
    reader.onerror = (error) => {
    };
  }

  send(): void {
    if (this.data['modal'].type == 7 && this.allRecords > 0) {
      Swal.fire({
        title: '¿Desea reemplazar el archivo ' + this.form.get('img').value + '?',
        returnInputValueOnDeny: false,
        icon: 'question',
        confirmButtonText: 'Aceptar',
        cancelButtonText: 'Cancelar',
        showCancelButton: true,
      }).then(next => {
        if (next.isConfirmed) {
          this.form.get('toReplace').setValue(true);
          this.sendData();
        }
      });
    } else {
      this.sendData();
    }
  }

  sendData(): void {
    const emitted = this.form.value;
    const preserveNullFields = ['img2', 'img642', 'img3', 'img643'];
    for (const item in emitted) {
      if (emitted.hasOwnProperty(item) && emitted[item] === null) {
        if (this.data['modal'].type === 9 && preserveNullFields.includes(item)) {
          continue;
        }
        delete emitted[item];
      }
    }
    this.activeModal.close(emitted);
  }

  fileManager(event, reader, e, order: number) {
    if (event.target.files[0].type.includes('image')) {
      const image = new Image();
      image.src = String(reader.result);
      image.onload = () => {
        this.messages['i'] = null;

        switch (order) {
          case 1: this.file = image.src; break;
          case 2: this.file2 = image.src; break;
          case 3: this.file3 = image.src; break;
          default: break;
        }

        var sufix = order == 1 ? "" : order;
        this.form.get(`img${sufix}`).setValue((event.target.files[0]).name);
        this.form.get(`img64${sufix}`).setValue(image.src.split(',')[1]);
        this.form.get(`img64${sufix}Upload`).setValue(true);
        this.validateReplace((event.target.files[0]).name);
      }
    } else {
      this.file = 'assets/images/file-icons/' + event.target.files[0].name.split('.')[1] + '.png';
      this.form.get('img').setValue((event.target.files[0]).name);
      if (typeof e.target.result === 'string') {
        this.form.get('img64').setValue(e.target.result.split(',')[1]);
      }
      this.form.get('img64Upload').setValue(true);
      this.form.get('size').setValue(event.target.files[0].size);
      this.form.get('type').setValue(event.target.files[0].name.split('.')[1]);
      this.validateReplace((event.target.files[0]).name);
    }
  }


  validateReplace(Img: string): void {
    const sub = this.filesManagerService.getItem(Img).pipe(finalize(() => {
      sub.unsubscribe();
      this.loader.updateLoadingValue(false);
    })).subscribe((response: HttpResponse<any>) => {
      this.allRecords = Number(response.headers.get('x-total-register'));
    });
  }

  clearImage(order: number): void {
    switch (order) {
      case 2:
        this.file2 = null;
        this.data.img2 = null;
        this.form.get('img2').setValue(null);
        this.form.get('img642').setValue(null);
        this.form.get('img642Upload').setValue(true);
        this.form.get('img2Clean').setValue(true);
        break;
      case 3:
        this.file3 = null;
        this.data.img3 = null;
        this.form.get('img3').setValue(null);
        this.form.get('img643').setValue(null);
        this.form.get('img643Upload').setValue(true);
        this.form.get('img3Clean').setValue(true);
        break;
    }
  }
}
